<template>
  <div
    class="header selected_container"
    :class="{
      scrolled: isScrolled,
    }"
  >
    <NuxtLink external class="logo" to="/" aria-label="Go to Travvir home"
      >Travvir</NuxtLink
    >
    <div
      v-if="$route.name == 'explorePlaces'"
      class="search"
      :class="{ open: searchActive }"
    >
      <div>
        <button
          v-if="searchActive"
          class="icon"
          type="button"
          aria-label="Close search"
          @click="searchActive = false"
        >
          <RiArrowLeftLine />
        </button>
      </div>
    </div>
    <nav class="short-cut" :class="{ open: menu }" aria-label="Primary">
      <NuxtLink to="/about" prefetch-on="visibility">About us</NuxtLink>
      <NuxtLink to="/docs" prefetch-on="visibility">Docs</NuxtLink>
      <NuxtLink to="/pricing" prefetch-on="visibility" v-if="false"
        >Pricing</NuxtLink
      >
      <NuxtLink to="/partnership" prefetch-on="visibility"
        >Partnerships</NuxtLink
      >
      <NuxtLink to="/enterprise" prefetch-on="visibility">Enterprise</NuxtLink>
      <a
        v-if="false"
        @click="handleOsBasedRedirection"
        target="_blank"
        rel="noopener noreferrer"
        >Login</a
      >
      <div class="download-buttons">
        <button
          class="download-app-btn android"
          @click="openPlayStore"
          type="button"
          aria-label="Download on Google Play"
        >
          <RiAndroidFill size="16px" />
          Android
        </button>
        <button
          class="download-app-btn ios"
          @click="openAppStore"
          type="button"
          aria-label="Download on App Store"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
            <path
              d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z"
            />
          </svg>
          iOS
        </button>
      </div>
      <button
        v-if="menu"
        class="icon"
        type="button"
        aria-label="Close menu"
        @click="closeMenu"
      >
        <RiCloseLine />
      </button>
    </nav>
    <div class="menu-options">
      <button
        v-if="!searchActive && $route.name == 'explorePlaces'"
        type="button"
        aria-label="Open search"
        @click="searchActive = true"
      >
        <RiSearchLine />
      </button>
      <button
        v-if="!menu"
        type="button"
        aria-label="Open menu"
        :aria-expanded="menu ? 'true' : 'false'"
        @click.stop="menu = true"
      >
        <RiMenu3Line />
      </button>
    </div>
  </div>
  <CookiesOverlay @click="saveAcceptTime" v-if="!isApp && !cookies && false" />
</template>
<script setup>
import {
  RiMenu3Line,
  RiCloseLine,
  RiSearchLine,
  RiArrowLeftLine,
  RiAndroidFill,
} from "@remixicon/vue";
import { useMiraStore } from "~/store/mira";
import { useLocalStorage } from "@vueuse/core";
const { $device, $isIPhone, $isMobile } = useNuxtApp();

const miraStore = useMiraStore();
console.log(miraStore.country, "country");

//variables
const menu = ref(false);
const cookies = ref(null);
const isScrolled = ref(false);
const config = useRuntimeConfig();

// const cookies = ref(localStorage.getItem("terms_accept_time"));
const searchActive = ref(false);
const browserInfo = ref({ os: "Unsupported" });

//computed
const isApp = computed(() => $device.isAndroidApp || $device.isIosApp);

//methods
function closeMenu() {
  menu.value = false;
}

function saveAcceptTime() {
  let val = JSON.stringify({ acceptedOn: new Date() });
  useLocalStorage("terms_accept_time", val);
  cookies.value = val;
}

function browser() {
  if (process.client) {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var os = detectOs(userAgent);
    return { os: os };
  }
}
function detectOs(agent) {
  if (navigator.userAgentData) return navigator.userAgentData.platform;
  else if (agent.includes("iPhone")) return "iOS";
  else if (agent.includes("Safari") && !agent.includes("Chrome"))
    return "MacOS";
  return "Unsupported";
}

function openAppStore() {
  window.open(
    "https://apps.apple.com/in/app/travvir-360-views-from-phone/id6443536819",
    "_blank"
  );
}

function openPlayStore() {
  window.open(
    "https://play.google.com/store/apps/details?id=com.travvir.studio",
    "_blank"
  );
}

function handleOsBasedRedirection() {
  if ($isMobile) {
    if ($isIPhone) openAppStore();
    else openPlayStore();
  } else {
    window.open(`${config.public.NUXT_BASE_URL}/app/auth/login`, "_blank");
  }
}

function handleClick() {
  if (browserInfo.os == "iOS") openAppStore();
  else if (browserInfo.os == "Android") openPlayStore();
  else window.location.href = "#contact-us";
}
function handleScroll() {
  isScrolled.value = window.scrollY > 50;
}

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
  cookies.value = useLocalStorage("terms_accept_time", null);
  browserInfo.value = browser();
});
onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>
<style scoped lang="scss">
.header {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0rem;
  color: #fff;
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  z-index: 9999;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: $theme-font;

  &.scrolled {
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    // height: 2.5rem;
  }
  &.selected_container {
    background: rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    padding: 0.2rem 3rem;

    @include respond-below(sm) {
      padding: 0.5rem 1rem;
    }

    .logo {
      color: white;
      text-decoration: none;
      @extend %v-center;
      text-decoration: none;
      height: auto;
      letter-spacing: -0.02rem;
      font-size: 1.6rem;
      font-weight: 600;
      background: linear-gradient(135deg, #fff 0%, #f0f0f0 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.02);
      }

      @include respond-below(sm) {
        font-size: 1.4rem;
        font-weight: 600;
      }
    }

    .short-cut {
      a {
        font-size: 0.875rem;
        display: flex;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.9);
        text-decoration: unset;
        // margin-right: 2rem;
        padding: 0.25rem 0.5rem;
        border-radius: 6px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;

        &:hover {
          color: #fff;
          transform: translateY(-1px);
        }

        &:before {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 0;
          height: 2px;
          background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
          transition: all 0.3s ease;
          transform: translateX(-50%);
        }
        &.router-link-active:before {
          width: 80%;
        }
        &.active:before {
          width: 80%;
        }

        &:hover:before {
          width: 80%;
        }

        @include respond-below(sm) {
          padding: 0.2rem 0.4rem;
          border-radius: 4px;
          font-size: 0.75rem;
        }
      }

      .download-buttons {
        display: flex;
        gap: 0.5rem;
        align-items: center;

        @include respond-below(md) {
          display: none;
          flex-direction: column;
          width: calc(100% - 3rem);
          gap: 0.3rem;
        }
      }

      .download-app-btn {
        background: transparent;
        border: 1px solid rgba(255, 255, 255, 0.3);
        outline: none;
        color: white;
        font-size: 0.675rem;
        font-weight: 500;
        padding: 0.35rem 0.6rem;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: none;
        font-family: inherit;
        min-width: 70px;
        display: flex;
        align-items: center;
        gap: 0.4rem;

        svg {
          flex-shrink: 0;
        }

        &:hover {
          transform: translateY(-1px) scale(1.02);
          background: rgba(255, 255, 255, 0.1);
          border-color: rgba(255, 255, 255, 0.5);
        }

        &:active {
          transform: translateY(0) scale(1.01);
        }

        &.ios {
          svg {
            color: white;
          }
        }

        @include respond-below(sm) {
          padding: 0.8rem 1.2rem;
          font-size: 1rem;
          width: 100%;
          border-radius: 10px;
          justify-content: center;
          gap: 0.6rem;

          svg {
            width: 18px;
            height: 18px;
          }
        }
      }
    }
  }

  @include respond-below(sm) {
    justify-content: space-between;
    padding: 0 1rem;
    height: 2.5rem;

    &.scrolled {
      height: 2.25rem;
    }
  }

  .logo {
    color: white;
    text-decoration: none;
    font-size: 1.3rem;
    letter-spacing: -0.01rem;
    font-weight: 600;
    background: linear-gradient(135deg, #fff 0%, #f0f0f0 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    transition: all 0.3s ease;
    display: block;

    &:hover {
      transform: scale(1.02);
    }

    @include respond-below(sm) {
      font-size: 1.1rem;
    }
  }

  .short-cut {
    @extend %flex-center;
    gap: 1.2rem;
    @extend %chat-text;

    a {
      font-size: 0.875rem;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.9);
      text-decoration: none;
      cursor: pointer;
      padding: 0.25rem 1rem;
      // margin-right: 1.5rem;
      border-radius: 6px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;

      &:hover {
        color: #fff;
        // background: rgba(255, 255, 255, 0.1);
        transform: translateY(-1px);
      }

      &.capture-btn {
        color: #fff;

        &:hover {
          transform: translateY(-1px);
        }
      }

      &.login-btn {
        // border: 1px solid rgba(255, 255, 255, 0.3);

        &:hover {
          border-color: rgba(255, 255, 255, 0.6);
          // background: rgba(255, 255, 255, 0.1);
        }
      }
    }

    &.open {
      display: revert;
      position: fixed;
      top: 0;
      left: 0;
      width: 18rem;
      height: 100vh;
      @supports not (height: 100vh) {
        height: 100%;
      }
      inset: 0;
      z-index: 111;
      background: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(20px);
      -webkit-backdrop-filter: blur(20px);
      display: flex;
      justify-content: start;
      padding-top: 3rem;
      align-items: start;
      flex-flow: wrap column;
      animation: slide-menu 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
      box-shadow: 0 0 50px rgba(0, 0, 0, 0.1);

      a {
        color: rgba(0, 0, 0, 0.8);
        padding: 0.8rem 1.5rem;
        margin: 0.3rem 0;
        font-size: 1.1rem;
        font-weight: 500;
        border-radius: 12px;
        width: calc(100% - 3rem);
        transition: all 0.3s ease;

        &:hover {
          background: rgba(102, 126, 234, 0.1);
          color: #667eea;
          transform: translateX(8px);
        }

        &.capture-btn {
          color: inherit;
        }
      }

      @keyframes slide-menu {
        from {
          left: -100%;
          opacity: 0;
        }
        to {
          left: 0;
          opacity: 1;
        }
      }

      .icon {
        position: absolute;
        right: 1.5rem;
        top: 1.5rem;
        color: #000;
        padding: 0.1rem;
        border-radius: 8px;
        transition: all 0.3s ease;

        &:hover {
          background: rgba(0, 0, 0, 0.1);
        }
      }
    }

    @include respond-below(md) {
      display: none;
      gap: 0.6rem;
      a {
        font-size: 0.75rem;
      }
    }
  }
}

.menu-options {
  display: none;
  @include respond-below(md) {
    gap: 0.7rem;
    display: flex;
    align-items: center;
  }

  svg {
    cursor: pointer;
    padding: 0.1rem;
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      transform: scale(1.1);
    }
  }
}

.search {
  @include respond-below(sm) {
    .search-dropdown {
      display: none;
    }
  }

  &.open {
    animation: slide-left 400ms cubic-bezier(0.4, 0, 0.2, 1) forwards;
    padding: 0.5rem 1rem;
    align-items: center;
    display: flex;
    flex-direction: row-reverse;
    background: rgba(0, 0, 0, 0.9);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    gap: 1rem;
    left: 0%;
    width: 100%;
    position: absolute;
    border-radius: 0 0 16px 16px;

    .search-dropdown {
      display: flex;
    }
  }
}
button {
  border: none;
  outline: none;
  background: transparent;
  color: inherit;
}

@keyframes slide-left {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
